import React, { Fragment } from "react"
import { Modal } from "react-bootstrap"
import { ButtonPrimary, ButtonPrimaryOutlined } from "./Buttons"


/**
 * ConfirmModal — a reusable, non-dismissible dark-themed confirmation dialog.
 *
 * Props:
 *   - show: boolean (controlled by parent)
 *   - title: string (modal heading)
 *   - message: string | JSX (the body text, left-aligned)
 *   - confirmText: string (default "Confirm")
 *   - cancelText: string (default "Cancel")
 *   - onConfirm: () => void (called when the user confirms)
 *   - onCancel: () => void (called when the user cancels — defaults to closing)
 */
const ConfirmModal = ({
	show,
	title,
	message,
	confirmText = "Confirm",
	cancelText = "Cancel",
	onConfirm,
	onCancel,
}) => {
	const handleCancel = () => {
		if (onCancel) onCancel()
	}

	return (
		<Modal
			show={show}
			onHide={handleCancel}
			backdrop="static"
			keyboard={false}
			centered
		>
			<Modal.Body style={{ padding: "24px", textAlign: "center", color: "white" }}>
				{title ? <h3>{title}</h3> : null}
				{title ? <br /> : null}
				<div style={{ fontSize: "16px", textAlign: "left" }}>
					{message}
				</div>
				<br />
				<div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
					<ButtonPrimaryOutlined
						onClick={handleCancel}
						style={{ borderRadius: "10em", padding: "8px 20px" }}
					>
						{cancelText}
					</ButtonPrimaryOutlined>
					<ButtonPrimary
						onClick={onConfirm}
						style={{ borderRadius: "10em", padding: "8px 20px" }}
					>
						{confirmText}
					</ButtonPrimary>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default ConfirmModal
